import analytics from '@/utils/analytics';
import { createRouter, createWebHistory } from 'vue-router';
import EventPageView from '@/views/EventPage/EventPageView.vue';
import TempHomeView from '@/views/TempHome/TempHomeView.vue';
import HomePageView from '@/views/HomePage/HomePageView.vue';
// import DayOfPageView from '@/views/DayOfPage/DayOfPageView.vue';
import WaitingRoomView from '@/views/WaitingRoom/WaitingRoomView.vue';
import AppointmentCalendarView from '@/views/AppointmentCalendar/AppointmentCalendarView.vue';

const defaultMetaTitle = 'Ford Pro';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePageView,
    meta: {
      title: 'Events - Ford Pro',
    },
    props: (route) => ({ eventType: route.query.eventType }),
  },
  {
    path: '/event/:id/reschedule/:sessionid',
    component: EventPageView,
    props: true,
    meta: {
      title: 'Event - Ford Pro',
    },
  },
  {
    path: '/event/:id/:register?',
    component: EventPageView,
    props: true,
    meta: {
      title: 'Event - Ford Pro',
    },
  },
  // {
  //   path: '/day-of/:id',
  //   component: DayOfPageView,
  //   props: (route) => ({
  //     id: route.params.id,
  //     email: route.query.email,
  //   }),
  // },
  {
    path: '/waiting-room/:id',
    name: 'WaitingRoom',
    component: WaitingRoomView,
    props: (route) => ({ id: route.params.id }),
  },
  {
    path: '/appointment-calendar/:id',
    name: 'AppointmentCalendar',
    component: AppointmentCalendarView,
    props: (route) => ({ id: route.params.id }),
  },
  {
    path: '/Experiment/',
    name: 'Experiment',
    component: TempHomeView,
    props: true,
    meta: {
      title: 'Dev - Experiment',
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

router.beforeEach(async (to) => {
  const { name, path } = to;
  analytics.trackPageView({ name: name || path, url: path });
  document.title = to.meta.title || defaultMetaTitle;
});

export default router;
